import { render, staticRenderFns } from "./ModifyFrontDisplay.vue?vue&type=template&id=dc197218&"
import script from "./ModifyFrontDisplay.vue?vue&type=script&lang=ts&"
export * from "./ModifyFrontDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports